// extracted by mini-css-extract-plugin
module.exports = {"pricing":"BasePricing_pricing_ZZ1rj"};